// src/contexts/GlobalContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

export const GlobalContext = createContext(null);

export const GlobalProvider = ({ children }) => {
  const [globalState, setGlobalState] = useState({
    setup: {
      config: {
        companyName: '',
        primaryDomain: '',
        tagline: '',
        logoUrl: '',
        backgroundUrl: '',
        primaryColor: '#000000',
        secondaryColor: '#ffffff',
        apiBaseUrl: '',
        defaultLocale: 'en-US',
        supportEmail: '',
        experimentalFeatures: false
      },
      isConfigured: false,
    }
  });

  const updateGlobalState = useCallback((section, key, value) => {
    setGlobalState((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value,
      },
    }));
  }, []);

  return (
    <GlobalContext.Provider value={{ globalState, updateGlobalState }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal must be used within a GlobalProvider');
  }
  return context;
};

export const useSetupWizard = () => {
  const { globalState, updateGlobalState } = useGlobal();

  const updateSetupConfig = useCallback((config) => {
    updateGlobalState('setup', 'config', config);
  }, [updateGlobalState]);

  const setConfigured = useCallback((isConfigured) => {
    updateGlobalState('setup', 'isConfigured', isConfigured);
  }, [updateGlobalState]);

  const setApiBaseUrl = useCallback((url) => {
    const newConfig = {
      ...globalState.setup.config,
      apiBaseUrl: url,
    };
    updateSetupConfig(newConfig);
  }, [globalState.setup.config, updateSetupConfig]);

  return {
    config: globalState.setup.config,
    isConfigured: globalState.setup.isConfigured,
    updateSetupConfig,
    setConfigured,
    setApiBaseUrl
  };
};
